import React from 'react';

import TypingIndicator from '../TypingIndicator';

const Loading = () => {
  return <TypingIndicator />;
};

export default Loading;
